<template>
  <component
    :is="tagName"
    :to="to"
    class="flex items-center justify-center w-8 h-8 text-gray-600 rounded-full hover:bg-gray-100 hover:text-gray-900"
    tag="button"
    type="button"
  >
    <span class="sr-only">Schließen</span>
    <svg
      aria-hidden="true"
      class="w-3 h-3 fill-current"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.41425 6.00001L11.7072 1.70701C12.0982 1.31601 12.0982 0.684006 11.7072 0.293006C11.3162 -0.0979941 10.6842 -0.0979941 10.2933 0.293006L6.00025 4.58601L1.70725 0.293006C1.31625 -0.0979941 0.68425 -0.0979941 0.29325 0.293006C-0.09775 0.684006 -0.09775 1.31601 0.29325 1.70701L4.58625 6.00001L0.29325 10.293C-0.09775 10.684 -0.09775 11.316 0.29325 11.707C0.48825 11.902 0.74425 12 1.00025 12C1.25625 12 1.51225 11.902 1.70725 11.707L6.00025 7.41401L10.2933 11.707C10.4882 11.902 10.7442 12 11.0002 12C11.2562 12 11.5122 11.902 11.7072 11.707C12.0982 11.316 12.0982 10.684 11.7072 10.293L7.41425 6.00001Z"
      />
    </svg>
  </component>
</template>

<script>
import { defineComponent, computed } from "@/composition-api";

export default defineComponent({
  props: {
    to: {
      type: [Object, null],
      default: null
    }
  },
  setup({ to }) {
    const tagName = computed(() => {
      return to !== null ? "router-link" : "button";
    });

    return {
      tagName
    };
  }
});
</script>
